import classNames from "classnames";
import Button from "components/Leasing/components/leasing.c.button";
import {
  prePareQueryRequest,
  getLastItem,
} from "components/Leasing/utils/leasing.u";
import { format } from "date-fns";
import _ from "lodash";
import { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import API from "../api/api.main";
import { Auth } from "aws-amplify";
import axios from "axios";
import numeral from "numeral";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let source = axios.CancelToken.source();

function LeasingReportContract({ startDate, endDate, interestDate }) {
  const [loading, setLoading] = useState(false);
  const [allContract, setAllContract] = useState([]);
  const [count, setCount] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (finished) {
      const doc = document.getElementById("export-excel-leasing-contract");
      doc.click();
    }
  }, [finished]);

  const getDefaultQuery = () => {
    const objQuery = {
      Limit: 1,
      loan_id: "",
      ScanIndexForward: false,
      status: "",
      category: "",
      min: startDate,
      max: endDate,
      fields: "",
    };
    return objQuery;
  };

  const fetchLeasingLoan = async (firstLoading = true) => {
    try {
      setLoading(firstLoading);
      setFinished(false);
      setCount(0);
      let localQuery = getDefaultQuery();
      let datas = [];
      let lastItem = null;

      do {
        const data = await API.get("MoneyHubAdmin", `/leasing/loan`, {
          queryStringParameters: {
            ...prePareQueryRequest(_.cloneDeep(localQuery)),
            ExclusiveStartKey: getLastItem(lastItem),
            showInstallment: true,
            paid_date: getCurrentLocalDateTime(interestDate).fullDate,
            isPhone: true,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
          cancelToken: source?.token,
        });

        let leasing_loans = data?.leasing_loans;
        lastItem = data?.lastItem;

        for (let leasing_loan of leasing_loans) {
          let interestFuture = 0;
          let interestReceive = 0;
          let allVat = 0;
          let allPenalty = 0;
          let allDemandFee = 0;
          let allVisitFee = 0;

          const { interfaceCreate } = await API.get(
            "MoneyHubAdmin",
            `/leasing/interfaceCreate/${leasing_loan?.loan_id}`,
            {
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
              cancelToken: source?.token,
            }
          );

          const { evidences } = await API.get(
            "MoneyHubAdmin",
            `/leasing/loan/evidences/${leasing_loan?.loan_id}`,
            {
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );

          const filterRemainDueEvidences = evidences?.filter(
            (evidence) => getCurrentLocalDateTime(evidence?.paidDate).fullDate > getCurrentLocalDateTime(interestDate).fullDate
          )

          if (filterRemainDueEvidences.length > 0) {
            for (const filterRemainDueEvidence of filterRemainDueEvidences) {
              leasing_loan.capitalRemain += filterRemainDueEvidence?.evidencePaidPrinciple;
            }
          }
         

          if (interfaceCreate) {
            leasing_loan.VENDOR_AMOUNT = interfaceCreate?.VENDOR_AMOUNT;
          }

          leasing_loan.allContractCancel = leasing_loan?.cancel_total_daily;

          if (leasing_loan?.category === "TF") {
            interestFuture = leasing_loan?.installments.reduce((prev, curr) => {
              return prev + curr?.interest;
            }, 0);
            leasing_loan.interestFuture = interestFuture;
          } else {
            for (let installment of leasing_loan.installments) {
              let last_pre_installment =
                installment?.pre_installments[
                  installment?.pre_installments?.length - 1
                ];
              if (last_pre_installment) {
                interestFuture += last_pre_installment?.interest;
              }
            }
          }

          for (let installment of leasing_loan.installments) {
            allVat += installment?.principle_vat + installment?.interest_vat;

            let last_pre_installment =
              installment?.pre_installments[
                installment?.pre_installments.length - 1
              ];
            let paid_pre_installments = installment?.pre_installments.filter(
              (pre_installment) => {
                let paidDateFormat = getCurrentLocalDateTime(
                  pre_installment?.paidDate
                ).fullDate;
                let checkCondition =
                  pre_installment?.pre_status === "PAID" &&
                  paidDateFormat <= interestDate;
                return checkCondition;
              }
            );
            interestReceive += paid_pre_installments.reduce((prev, curr) => {
              return prev + curr.paidInterest;
            }, 0);

            allPenalty += last_pre_installment
              ? last_pre_installment?.penalty
              : 0;

            allDemandFee += last_pre_installment
              ? last_pre_installment?.demand_fee
              : 0;

            allVisitFee += last_pre_installment
              ? last_pre_installment?.visit_fee
              : 0;
          }

          leasing_loan.interestFuture = interestFuture;
          leasing_loan.interestReceive = interestReceive;
          leasing_loan.allVat = allVat;
          leasing_loan.allPenalty = allPenalty;
          leasing_loan.allDemandFee = allDemandFee;
          leasing_loan.allVisitFee = allVisitFee;
        }

        datas = [...datas, ...leasing_loans];
        setCount(datas?.length);
      } while (lastItem);

      console.log("datas", datas);
      setAllContract(datas);
      setFinished(true);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const borders = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  const style = {
    font: { sz: 14, name: "Cordia New" },
    border: borders,
    alignment: { vertical: "center", horizontal: "center" },
    fill: { fgColor: { rgb: "dbdbdb" } },
  };

  const getColumnHistoryPhone = () => {
    let maxHistoryPhone = 0;
    let lastMaxIndex = 0;
    for (let i = 0; i < allContract.length; i++) {
      const item = allContract[i];
      if (item?.profile?.previousPhone) {
        let splitHistoryPhone = String(item?.profile?.previousPhone).split(" ");
        splitHistoryPhone = splitHistoryPhone.filter(
          (previousPhone) => previousPhone
        );
        if (splitHistoryPhone.length > maxHistoryPhone) {
          maxHistoryPhone = splitHistoryPhone.length;
          lastMaxIndex = i;
        }
      }
    }

    let columnHistoryPhone = [];
    for (let index = 0; index < maxHistoryPhone; index++) {
      columnHistoryPhone.push({
        title: `History Phone ${index + 1}`,
        width: { wch: 24 },
        style: style,
      });
    }

    return {
      columnHistoryPhone,
      maxHistoryPhone,
      lastMaxIndex,
    };
  };

  const createDataWithStyleContract = (data = []) => {
    var result = [];

    let styleTwo = _.cloneDeep(style);

    delete styleTwo?.fill;

    for (let i = 0; i < data.length; i++) {
      const currentAddress = data[i]?.currentAddress;

      const [
        currentAddressDistrict,
        currentAddressSubDistrict,
        currentAddressProvince,
        currentAddressCode,
      ] = currentAddress?.split(",");

      const [
        addressDistrict,
        addressSubDistrict,
        addressProvince,
        addressCode,
      ] = data[i]?.address?.split(",");

      const previousPhone = data[i]?.profile?.previousPhone;
      let listHistoryPhone = [];
      if (previousPhone) {
        const splitHistoryPhone = previousPhone.split(" ");
        for (const itemSplitHistoryPhone of splitHistoryPhone) {
          listHistoryPhone.push({
            value: itemSplitHistoryPhone,
            style: styleTwo,
          });
        }
      }

      result.push([
        {
          value: i + 1,
          style: styleTwo,
        },
        {
          value: data[i]?.loan_id || "",
          style: styleTwo,
        },
        {
          value: data[i]?.citizenid || "",
          style: styleTwo,
        },
        {
          value: { NTF: "จำนำ", TF: "เช่าซื้อ" }[data[i]?.category],
          style: styleTwo,
        },
        {
          value: {
            CAR: "รถยนต์",
            MOTORBIKE: "รถจักรยานยนต์",
            TRUCK: "รถกระบะ",
          }[data[i]?.type],
          style: styleTwo,
        },
        {
          value: data[i]?.raw_interest,
          style: styleTwo,
        },
        {
          value: data[i]?.brand,
          style: styleTwo,
        },
        {
          value: data[i]?.subModel,
          style: styleTwo,
        },
        {
          value: data[i]?.plate_province,
          style: styleTwo,
        },
        {
          value: data[i]?.year,
          style: styleTwo,
        },
        {
          value: data[i]?.gear,
          style: styleTwo,
        },
        {
          value: data[i]?.color,
          style: styleTwo,
        },
        {
          value: data[i]?.tankNumber,
          style: styleTwo,
        },
        {
          value: data[i]?.serialNumber,
          style: styleTwo,
        },
        {
          value: data[i]?.name + " " + data[i]?.lastname,
          style: styleTwo,
        },
        {
          value: data[i]?.gender,
          style: styleTwo,
        },
        {
          value: data[i]?.age,
          style: styleTwo,
        },
        {
          value: data[i]?.marritalStatus,
          style: styleTwo,
        },
        {
          value: data[i]?.education,
          style: styleTwo,
        },
        {
          value: data[i]?.jobposition,
          style: styleTwo,
        },
        {
          value: numeral(data[i]?.income).format("0,000"),
          style: styleTwo,
        },
        {
          value: numeral(
            +data[i].income - +data[i].burden - +data[i].burdenSum
          ).format("0,000"),
          style: styleTwo,
        },
        {
          value: `${data[i]?.officialAddressCode} ${data[i]?.officialAddressDesc}`,
          style: styleTwo,
        },
        {
          value: `${currentAddressSubDistrict || ""}`,
          style: styleTwo,
        },
        {
          value: `${currentAddressDistrict || ""}`,
          style: styleTwo,
        },
        {
          value: `${currentAddressProvince || ""}`,
          style: styleTwo,
        },
        {
          value: `${currentAddressCode || ""}`,
          style: styleTwo,
        },
        {
          value: `${data[i]?.addressCode} ${data[i]?.addressDesc}`,
          style: styleTwo,
        },
        {
          value: `${addressSubDistrict || ""}`,
          style: styleTwo,
        },
        {
          value: `${addressDistrict || ""}`,
          style: styleTwo,
        },
        {
          value: `${addressProvince || ""}`,
          style: styleTwo,
        },
        {
          value: `${addressCode || ""}`,
          style: styleTwo,
        },
        {
          value: `${data[i]?.loan_status || ""}`,
          style: styleTwo,
        },
        {
          value: `${data[i]?.stamp_amount || "0"}`,
          style: styleTwo,
        },
        {
          value: `${
            numeral(data[i]?.fee_motorbike_amount).format("0,000.00") || "0"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            numeral(data[i]?.estimate_car_amount).format("0,000.00") || "0"
          }`,
          style: styleTwo,
        },
        {
          value: `${data[i]?.VENDOR_AMOUNT || "0"}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.initCapital).format("0,000") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.capitalRemain).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.interestFuture).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${
            numeral(data[i]?.interestReceive).format("0,000.00") || ""
          }`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allVat).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allPenalty).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allDemandFee).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allVisitFee).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${
            numeral(data[i]?.allContractCancel).format("0,000.00") || ""
          }`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allExpense).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allService).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allServiceVat).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${data[i].period || "-"}`,
          style: styleTwo,
        },
        {
          value: `${
            format(new Date(data[i]?.transferDate), "dd/MM/yyyy") || "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            format(new Date(data[i]?.endDueDate), "dd/MM/yyyy") || "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${numeral(data[i]?.allPenalty).format("0,000.00") || ""}`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.completedAt !== "-"
              ? format(new Date(data[i]?.completedAt), "dd/MM/yyyy")
              : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.completedBy !== "-" ? `${data[i]?.completedBy}` : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.approvedAt !== "-"
              ? format(new Date(data[i]?.approvedAt), "dd/MM/yyyy")
              : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.approvedBy !== "-" ? `${data[i]?.approvedBy}` : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.appointBy !== "-" ? `${data[i]?.approvedBy}` : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.appoint_date !== "-" ? `${data[i]?.appoint_date}` : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.overdue_date !== "-"
              ? `${format(new Date(data[i]?.overdue_date), "dd/MM/yyyy")}`
              : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${
            data[i]?.paidDateLatest !== "-"
              ? `${format(new Date(data[i]?.paidDateLatest), "dd/MM/yyyy")}`
              : "-"
          }`,
          style: styleTwo,
        },
        {
          value: `${data[i]?.phone_number}`,
          style: styleTwo,
        },
        ...listHistoryPhone,
      ]);
    }
    return result;
  };

  const multiDataSetContract = [
    {
      columns: [
        {
          title: "No",
          width: { wch: 10 },
          style: style,
        },
        {
          title: "เลขที่สัญญา",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "บัตรประชาชน",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "ประเภทสัญญา",
          width: { wch: 12 },
          style: style,
        },
        {
          title: "ประเภทรถ",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "อัตราดอกเบี้ย FLAT RATE",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "แบรนด์รถ",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "รุ่นย่อย",
          width: { wch: 40 },
          style: style,
        },
        {
          title: "จังหวัดทะเบียนรถ",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "ปีที่จดทะเบียนรถ",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "เกียร์",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "สี",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "เลขตัวถัง",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "เลขเครื่อง",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "ชื่อ - นามสกุล",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "เพศ",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "อายุ",
          width: { wch: 14 },
          style: style,
        },
        {
          title: "สถานะ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ระดับการศึกษา",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "อาชีพ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "รายรับ / เดือน",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "รายรับคงเหลือ / เดือน",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ที่อยู่ปัจจุบัน (บ้านเลขที่ / ถนน / ซอย)",
          width: { wch: 40 },
          style: style,
        },
        {
          title: "ที่อยู่ปัจจุบัน (ตำบล)",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "ที่อยู่ปัจจุบัน (อำเภอ)",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "ที่อยู่ปัจจุบัน (จังหวัด)",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "ที่อยู่ปัจจุบัน (รหัสไปรษณีย์)",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (บ้านเลขที่ / ถนน / ซอย)",
          width: { wch: 38 },
          style: style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (ตำบล)",
          width: { wch: 28 },
          style: style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (อำเภอ)",
          width: { wch: 28 },
          style: style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (จังหวัด)",
          width: { wch: 28 },
          style: style,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (รหัสไปรษณีย์)",
          width: { wch: 24 },
          style: style,
        },
        {
          title: "Status",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าอากรแสตมป์",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าธรรมเนียมการใช้วงเงิน",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าธรรมเนียมการประเมินราคารถยนต์",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ยอดสินเชื่อที่ลูกค้าได้รับ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ยอดสินเชื่อทั้งหมด",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ยอดสินเชื่อคงเหลือ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ดอกเบี้ยประมาณการ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ดอกเบี้ยที่ได้รับแล้ว",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ภาษีมูลค่าเพิ่ม",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ดอกเบี้ยผิดนัด",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าทวงถาม",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าลงพื้นที่",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่ายกเลิกสัญญา",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าเสียผลประโยชน์ทางทรัพย์",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าบริการ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ค่าบริการ (ภาษีมูลค่าเพิ่ม)",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "วันที่เริ่มต้นสัญญา",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "วันที่สิ้นสุดสัญญา",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "ดอกเบี้ยสะสม จากการค้างชำระ",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Complete Date",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Complete By",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Approve Date",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Approve By",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "FCR By",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "FCR Date",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Overdue Date",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Last Payment Date",
          width: { wch: 20 },
          style: style,
        },
        {
          title: "Phone",
          width: { wch: 20 },
          style: style,
        },
        ...getColumnHistoryPhone().columnHistoryPhone,
      ],
      data: createDataWithStyleContract(allContract),
    },
  ];

  return (
    <div>
      <Button
        disabled={loading}
        loading={loading}
        onClick={fetchLeasingLoan}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
      >
        {loading ? `Loading... ${count}` : "Report Contract"}
      </Button>

      <ExcelFile
        filename={`ALL_LEASING_CONTRACT_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-leasing-contract" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetContract}
          name="All Leasing Contract"
        ></ExcelSheet>
      </ExcelFile>
    </div>
  );
}

export default LeasingReportContract;
